import React, { useState } from 'react'
import { ToastContainer } from 'react-toastify'
import { DateFormat } from '../../utils/DateFormat';
import { Link } from 'react-router-dom'
import { BsPencil } from 'react-icons/bs'
import { MdOutlineMail } from "react-icons/md";

const ListActiveOrder = ({ products, loading, handleEditOrder, sendEmail, offset}) => {
    const [emailLoadingId, setEmailLoadingId] = useState(null); // ⬅ Track loading by product ID

    const today = new Date().toISOString().split('T')[0];
    const activeOrders = products?.filter(product =>
        product?.expiry_date && product?.expiry_date.split('T')[0] > today
    );

    const calculateDaysBetween = (start, end) => {
        const startDate = new Date(start);
        const endDate = new Date(end);
        const diffTime = endDate.getTime() - startDate.getTime();
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // Convert ms to days
        return diffDays;
    };

    const sendRenewalEmail = async (id) => {
        setEmailLoadingId(id);
        const emailSent = await sendEmail(id, 'renewal')
        if (emailSent) {
            setEmailLoadingId(null)
        }
    }

    const handleEdit = async (id, customerId) => {
        handleEditOrder(id, customerId)
    }

    return (
        <>
            <table className="table table-sm table-nowrap">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Order Id</th>
                        <th>Customer Name</th>
                        <th>Product Name</th>
                        <th>Type</th>
                        <th>Product Type</th>
                        <th>Start Date</th>
                        <th>Expiry Date</th>
                        <th>Quantity</th>
                        <th>ID Code</th>
                        <th>Days to go</th>
                        <th>status</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {loading ? (
                        <tr>
                            <td colSpan="9" className="text-center">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </td>
                        </tr>
                    ) : activeOrders.length > 0 ? (
                        activeOrders.map((order, index) => (
                            <tr key={order.id}>
                                <td>{offset + index + 1}</td>
                                <td>{order.id}</td>
                                <td>{order?.customer?.company ?? 'N/A'}</td>
                                <td>{order?.product?.name}</td>
                                <td>{order?.product?.type}</td>
                                <td>{order?.product_type}</td>
                                <td>{DateFormat(order?.start_date)}</td>
                                <td>{DateFormat(order?.expiry_date)}</td>
                                <td>{order?.quantity}</td>
                                <td>{order?.product?.identification_code}</td>
                                <td>{calculateDaysBetween(order?.start_date, order?.expiry_date)} Days</td>
                                <td>
                                    <span className={`badge ${order?.status === 'inactive'
                                        ? 'bg-dark'
                                        : order?.expiry_date.split('T')[0] > today
                                            ? 'bg-success'
                                            : 'bg-danger'
                                        }`}>
                                        {
                                            order?.status === 'inactive'
                                                ? 'Inactive'
                                                : order?.expiry_date.split('T')[0] > today
                                                    ? 'Active'
                                                    : 'Expired'
                                        }
                                    </span>
                                </td>
                                <td>
                                    <Link to="#" onClick={() => handleEdit(order.id, order?.customer_id)}>
                                        <BsPencil title="Edit" />
                                    </Link>

                                    {calculateDaysBetween(order.start_date, order.expiry_date) < 30 && (
                                        <>
                                            {' | '}
                                            {emailLoadingId === order.id ? (
                                                <div className="spinner-border spinner-border-sm text-danger ms-2" role="status">
                                                    <span className="visually-hidden">Sending...</span>
                                                </div>
                                            ) : (
                                                <Link to="#" className="text-primary ms-2" onClick={() => sendRenewalEmail(order.id)}>
                                                    <MdOutlineMail title="Send Email" />
                                                </Link>
                                            )}
                                        </>
                                    )}

                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="11" className="text-center">No order available</td>
                        </tr>
                    )}
                </tbody>
            </table>
            <ToastContainer />
        </>
    )
}

export default ListActiveOrder